import { render } from "./BuildingsSettingsView.vue?vue&type=template&id=0d66212a"
import script from "./BuildingsSettingsView.vue?vue&type=script&lang=js"
export * from "./BuildingsSettingsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__